{
  "name": "serv-e-go-frontend",
  "version": "3.10.3",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=remoteAPI --host 0.0.0.0 --port 4200",
    "start:testAPI": "ng serve --configuration=testAPI --host 0.0.0.0 --port 4200",
    "start:wiremock": "ng serve --configuration=wiremock --host 0.0.0.0 --port 4201",
    "watch": "ng serve --configuration=local",
    "wiremock:up": "docker compose up wiremock -d",
    "wiremock:down": "docker compose down wiremock",
    "wiremock:logs": "docker compose logs -f wiremock",
    "wiremock:reload": "curl -X POST http://localhost:8081/__admin/mappings/reset",
    "build": "ng build --output-hashing=bundles --configuration production --stats-json",
    "build:local": "ng build --output-hashing=bundles --configuration=local",
    "check:commit-message": "commitlint --config .commitlintrc.cjs --edit",
    "lint": "npm run check:playwright-unused-screenshots && npx eslint . && npx stylelint \"src/**/*.{scss,css}\" && npx prettier --check .",
    "check:pre-push": "npm run check:visual-impact && npm run check:typecheck-advisory",
    "check:typecheck-advisory": "mkdir -p node_modules/.cache && npm run typecheck:incremental -- --pretty false > node_modules/.cache/servego-typecheck.log 2>&1 || echo \"Typecheck is advisory while strict errors remain; see node_modules/.cache/servego-typecheck.log\"",
    "check:visual-impact": "node tools/hooks/check-visual-impact.mjs",
    "typecheck": "tsc -p tsconfig.json --noEmit --skipLibCheck",
    "typecheck:incremental": "tsc -p tsconfig.json --noEmit --skipLibCheck --incremental --tsBuildInfoFile node_modules/.cache/servego-typecheck.tsbuildinfo",
    "prettier": "prettier --write ./src/app/**/*.ts",
    "postbuild": "node ./postbuild/index.js",
    "checkTrad": "node tools/i18n/findMissingKeys.js",
    "test": "ng test --watch=false --browsers=ChromeHeadlessCI --source-map",
    "test:watch": "ng test --watch=true --browsers=ChromeHeadlessCI --source-map",
    "test:coverage": "npm run test -- --code-coverage",
    "test:ci": "npm run test -- --code-coverage --reporters=progress,junit",
    "test:integration:bdd": "TS_NODE_PROJECT=tests/integration/tsconfig.json cucumber-js",
    "test:integration:bdd:run": "tests/integration/run-bdd-tests.sh",
    "test:integration:bdd:run:progress": "tests/integration/run-bdd-tests.sh --profile progress",
    "test:integration:ci": "tests/integration/run-bdd-tests-ci.sh",
    "test:visual:ci": "npx playwright test --shard=${CI_NODE_INDEX:-1}/${CI_NODE_TOTAL:-1}",
    "test:ihm": "npm run build:local && npm run test:ihm:linux",
    "test:ihm:linux": "docker compose -f tests/visual-regression-tests/docker/docker-compose.yml down --remove-orphans && docker compose -f tests/visual-regression-tests/docker/docker-compose.yml run servego-playwright npx playwright test",
    "test:ihm:linux-storybook": "npm run test:ihm:linux -- --project=storybook-chromium --project=storybook-firefox --project=storybook-webkit",
    "test:ihm:linux-storybook-update": "npm run test:ihm:linux-storybook -- --update-snapshots",
    "test:ihm-build-docker-image": "docker build -t servego-playwright tests/visual-regression-tests/docker/",
    "test:ihm-report": "npx playwright show-report",
    "test:ihm-clean": "find . -type d -name '*-snapshots' -exec sh -c 'rm -f \"$0\"/*.png' {} \\;",
    "test:ihm-update-snapshots": "npm run build:local && npm run test:ihm:linux -- --update-snapshots",
    "docker-build": "docker build -f dockerfiles/Dockerfile --target=server .",
    "bundle-report": "webpack-bundle-analyzer dist/stats.json",
    "outdated": "npx --yes -- check-outdated --ignore-pre-releases --columns name,current,latest,changes --types minor,patch,reverted",
    "prepare": "husky",
    "update-i18n": "bash update-i18n.sh",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build -o storybook-static",
    "docker:storybook": "docker compose -f storybook/docker-compose.yml up storybook",
    "check:playwright-unused-screenshots": "ts-node --transpile-only --project tools/playwright/tsconfig.json tools/playwright/check-unused-screenshots.ts",
    "delete:playwright-unused-screenshots": "ts-node --transpile-only --project tools/playwright/tsconfig.json tools/playwright/delete-unused-screenshots.ts"
  },
  "engines": {
    "node": "^24.0.0",
    "npm": "^12.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "21.2.14",
    "@angular/animations": "21.2.16",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.16",
    "@angular/compiler": "21.2.16",
    "@angular/core": "21.2.16",
    "@angular/forms": "21.2.16",
    "@angular/material": "21.2.14",
    "@angular/material-luxon-adapter": "21.2.14",
    "@angular/platform-browser": "21.2.16",
    "@angular/platform-browser-dynamic": "21.2.16",
    "@angular/router": "21.2.16",
    "@daily-co/daily-js": "0.90.0",
    "@ngrx/effects": "21.1.1",
    "@ngrx/router-store": "21.1.1",
    "@ngrx/store": "21.1.1",
    "@ngx-translate/core": "18.0.0",
    "angular-auth-oidc-client": "21.0.2",
    "bootstrap": "5.3.8",
    "chart.js": "4.5.1",
    "flat": "6.0.1",
    "jsonpath-plus": "10.4.0",
    "leaflet": "1.9.4",
    "leaflet.markercluster": "1.5.3",
    "luxon": "3.7.2",
    "ng2-charts": "10.0.0",
    "ngx-mask": "21.0.1",
    "rxjs": "7.8.2",
    "socket.io-client": "4.8.3",
    "tslib": "2.8.1",
    "unleash-proxy-client": "3.8.2",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@analogjs/storybook-angular": "2.6.0",
    "@angular-devkit/architect": "0.2102.14",
    "@angular-devkit/build-angular": "21.2.14",
    "@angular-eslint/builder": "21.4.0",
    "@angular/build": "21.2.14",
    "@angular/cli": "21.2.14",
    "@angular/compiler-cli": "21.2.16",
    "@angular/language-service": "21.2.16",
    "@commitlint/cli": "21.2.1",
    "@commitlint/config-conventional": "21.2.0",
    "@cucumber/cucumber": "13.0.0",
    "@cucumber/pretty-formatter": "4.0.0",
    "@ngrx/schematics": "21.1.1",
    "@ngrx/store-devtools": "21.1.1",
    "@playwright/test": "1.62.1",
    "@storybook/addon-a11y": "10.4.2",
    "@storybook/addon-docs": "10.4.2",
    "@storybook/angular": "10.4.2",
    "@types/jasmine": "6.0.0",
    "@types/leaflet": "1.9.21",
    "@types/leaflet.markercluster": "1.5.6",
    "@types/luxon": "3.7.1",
    "@types/node": "24.13.0",
    "angular-eslint": "21.4.0",
    "eslint": "10.4.1",
    "eslint-import-resolver-typescript": "4.4.5",
    "eslint-plugin-import-x": "4.16.2",
    "eslint-plugin-storybook": "10.4.2",
    "http-server": "14.1.1",
    "husky": "9.1.7",
    "jasmine-core": "6.2.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-firefox-launcher": "2.1.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.2.0",
    "karma-junit-reporter": "2.0.1",
    "lint-staged": "17.0.7",
    "poeditorial": "2.2.1",
    "prettier": "3.8.3",
    "socket.io-mock": "1.3.2",
    "storybook": "10.4.2",
    "stylelint": "17.12.0",
    "stylelint-config-standard-scss": "17.0.0",
    "stylelint-order": "8.1.1",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "8.60.1",
    "webpack-bundle-analyzer": "5.3.0"
  },
  "lint-staged": {
    "src/{app,environments,styles}/**/*.ts": [
      "prettier --write",
      "eslint --fix"
    ],
    "src/{app,environments,styles}/**/*.{scss,css,md}": [
      "prettier --write",
      "stylelint --fix"
    ],
    "src/{app,environments,styles}/**/*.html": [
      "prettier --write",
      "eslint --fix"
    ]
  }
}
